import * as React from 'react'

import { F0Select } from '@factorialco/f0-react'
import { CardSelectableContainer, Textarea } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import { TeamRecord, useTeamSelectorSource } from 'modules/teams/lib/formFields/team/source'

import { WizardData } from 'modules/employees/components/UnifiedAddEmployeeModal/types'

const IT_SETUP_TICKET_VALUE = 'it_setup_ticket'

interface DeviceRequestCardProps {
  data: WizardData
  onDataChanged: (updated: WizardData) => void
}

export const DeviceRequestCard: React.FC<DeviceRequestCardProps> = ({ data, onDataChanged }) => {
  const teamSource = useTeamSelectorSource()

  const isRequestedDevicesEnabled = data.requestedDevicesEnabled ?? false

  const handleTeamChange = (teamId: string) => {
    onDataChanged({ ...data, requestedDevicesResponsibleTeamId: teamId || undefined })
  }

  const handleToggle = (value: string | undefined) => {
    const enabled = value === IT_SETUP_TICKET_VALUE
    onDataChanged({
      ...data,
      requestedDevicesEnabled: enabled,
      requestedDevicesNotes: enabled ? (data.requestedDevicesNotes ?? '') : undefined,
      requestedDevicesResponsibleTeamId: enabled
        ? data.requestedDevicesResponsibleTeamId
        : undefined,
    })
  }

  const handleContextChange = (value: string) => {
    onDataChanged({ ...data, requestedDevicesNotes: value })
  }

  return (
    <CardSelectableContainer
      isToggle
      value={isRequestedDevicesEnabled ? IT_SETUP_TICKET_VALUE : undefined}
      onChange={handleToggle}
      items={[
        {
          value: IT_SETUP_TICKET_VALUE,
          title: i18n.t('add_employee_modal.devices_step.get_devices_ready_title'),
          description: i18n.t('add_employee_modal.devices_step.get_devices_ready_description'),
          selectedContent: (
            <>
              <F0Select
                label={i18n.t('add_employee_modal.devices_step.it_setup_ticket_responsible_label')}
                placeholder={i18n.t(
                  'add_employee_modal.devices_step.it_setup_ticket_responsible_placeholder'
                )}
                value={data.requestedDevicesResponsibleTeamId}
                onChange={handleTeamChange}
                source={teamSource}
                mapOptions={(team: TeamRecord) => ({ label: team.name, value: team.id })}
                showSearchBox
                clearable
                required
              />
              <Textarea
                label={i18n.t('add_employee_modal.devices_step.get_devices_ready_context_label')}
                placeholder={i18n.t(
                  'add_employee_modal.devices_step.get_devices_ready_context_placeholder'
                )}
                value={data.requestedDevicesNotes ?? ''}
                onChange={(value) => handleContextChange(value)}
                rows={4}
                required
              />
            </>
          ),
        },
      ]}
    />
  )
}
